import React from 'react';
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../../../_metronic/_helpers";
import ErrorMessage from './ErrorMessage';


const DeleteExchangeRate = ({show, action: {action, error, data}, onHide}) => {
    const {meta: oldData} = data
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/files/jpg.svg")}
                        />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <ErrorMessage {...{error}} />
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">From Currency</h6>
                        <span className="text-muted">{oldData?.fromCurrency}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">To Currency</h6>
                        <span className="text-muted">{oldData?.toCurrency}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Rate</h6>
                        <span className="text-muted">{oldData?.rate}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">User Group</h6>
                        <span className="text-muted">{oldData?.userGroup}</span>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteExchangeRate;